import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';

import i18n from 'kodyl-js/i18n/react';
import { getContact, setLastDwelling } from '../../redux/modules/dwelling';
import { getSession } from '../../redux/modules/auth';
import LastDwelling from '../../common/last-dwelling';
import TermsModal from '../../common/modal/terms';
import { goal } from 'kodyl-js/tracking';
import paymentError from 'kodyl-js/payment/errors';
import withQuery from 'app/hooks/withQuery';
import { Stripe } from './stripe';
@connect(
  ({ i18n, auth: { user, existingUser }, dwelling: { lastDwelling } }) => ({
    i18n,
    user,
    existingUser,
    lastDwelling
  }),
  { getSession, getContact, setLastDwelling }
)
@i18n
class SubscriptionForm extends Component {
  constructor(props) {
    super(props);
    this._refs = {};
    // const sca = __SERVER__ || window.innerWidth < 400 ? false : true;

    this.state = {
      error: null,
      showTerms: false,
      loading: false,
      expiry: {},
      errors: {}, // form fields
      fields: {}
    };

    this.handlePaymentError = this.handlePaymentError.bind(this);

    goal({ name: 'InitiateCheckout' });
  }

  modalShow = ev => {
    ev.preventDefault();
    this.setState({ showTerms: true });
  };

  handlePaymentError(err) {
    if (err?.code === 30) {
      return;
    }

    const { errors } = this.state;

    let errorMessage;

    const error = errorMessage || paymentError('generic');

    // this.onError(error, err);
    this.setState({ error, errors, show3dsecure: false, loading: false });
  }

  getMeta = async () => {
    const form = document.querySelector('#payment-form');

    const fields = [
      'name',
      'address',
      'zipcode',
      'city',
      'country',
      'phone',
      'email'
    ];

    return fields.reduce((acc, key) => {
      acc[key] = form[key].value;
      return acc;
    }, {});
  };

  render() {
    const { user, offer } = this.props;
    const { showTerms } = this.state;

    return (
      <>
        <Row>
          <Col xs={12}>
            <LastDwelling page="subscription" />
          </Col>
          <Col
            xs={12}
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center'
            }}
          >
            {/* <h2>{ this.i18n(offer.labels.product) }</h2> */}
            <form
              className="form-horizontal"
              style={{ width: 'auto' }}
              ref={node => (this._refs.form = node)}
              id="payment-form"
              name="payment-form"
              action="#"
              method="POST"
              onSubmit={this.submit}
              autoComplete="on"
              noValidate
            >
              {this.state.error ? (
                <div className="payment-errors alert alert-danger" role="alert">
                  {this.i18n(this.state.error)}
                </div>
              ) : null}

              <div className="row credit-card-input">
                <div
                  className="col-sm-6 client-details"
                  style={{ width: 'auto' }}
                >
                  <div className="form-section-label">
                    <h3>{this.i18n('Your details')}</h3>
                  </div>
                  <div className="form-group row">
                    <label className="control-label col-md-4">
                      {this.i18n('Full name')}
                    </label>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        placeholder={this.i18n('Name')}
                        name="name"
                        defaultValue={user ? user.name : null}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="control-label col-md-4">
                      {this.i18n('Address')}
                    </label>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        placeholder={this.i18n('Address')}
                        name="address"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xs-4 col-md-12">
                      <div className="form-group row">
                        <label className="control-label col-md-4">
                          {this.i18n('Zipcode')}
                        </label>
                        <div className="col-md-8">
                          <input
                            className="form-control"
                            placeholder={this.i18n('Zip')}
                            name="zipcode"
                            pattern="[0-9]*"
                            noValidate
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-xs-8 col-md-12">
                      <div className="form-group row">
                        <label className="control-label col-md-4">
                          {this.i18n('City')}
                        </label>
                        <div className="col-md-8">
                          <input
                            className="form-control"
                            placeholder={this.i18n('City')}
                            name="city"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group row" style={{ display: 'none' }}>
                    <label className="control-label col-md-4">
                      {this.i18n('Country')}
                    </label>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        placeholder={this.i18n('Country')}
                        name="country"
                        defaultValue="Danmark"
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="control-label col-md-4">
                      {this.i18n('Phone')}
                    </label>
                    <div className="col-md-8">
                      <input
                        className="form-control"
                        placeholder={this.i18n('Phone')}
                        name="phone"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="control-label col-md-4">
                      {this.i18n('Email address')}
                    </label>
                    <div className="col-md-8">
                      <input
                        type="email"
                        className="form-control"
                        placeholder={this.i18n('Email address')}
                        name="email"
                        defaultValue={user ? user.email : null}
                      />
                    </div>
                  </div>
                  <div className="form-section-label">
                    <h3>{this.i18n('Product and price')}</h3>
                  </div>
                  <table className="table table-striped table-responsive">
                    <tbody>
                      <tr>
                        <th>{this.i18n('Intro price')}</th>
                        <td>
                          {this.i18n(offer.labels.oneoff, ...offer.oneoff)}
                        </td>
                      </tr>
                      <tr>
                        <th>{this.i18n('Recurring price')}</th>
                        <td>
                          {this.i18n(
                            offer.labels.recurring,
                            ...offer.recurring
                          )}
                          i løbende abonnement indtil dette opsiges.
                          <br />
                          <em>
                            <small>
                              {this.i18n(
                                'First time after %s days',
                                offer.recurring[3]
                              )}
                            </small>
                          </em>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </form>
            <div
              className="col-sm-6"
              style={{ width: 'auto' }}
              ref={node => (this._refs.payment = node)}
            >
              <div className="form-section-label">
                <h3>{this.i18n('Payment Details')}</h3>
              </div>
              <Stripe
                plan={this.props.offer.name}
                user={this.props.user}
                i18n={text => this.i18n(text)}
                error={this.state.error}
                getMeta={this.getMeta}
                modalShow={this.modalShow}
              />
            </div>
            <TermsModal
              onClose={() => this.setState({ showTerms: false })}
              show={showTerms}
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default withQuery(SubscriptionForm);
